import { render, staticRenderFns } from "./AddToHomeScreenBanner.vue?vue&type=template&id=00b5e45a&scoped=true&lang=pug&"
import script from "./AddToHomeScreenBanner.vue?vue&type=script&lang=ts&"
export * from "./AddToHomeScreenBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AddToHomeScreenBanner.vue?vue&type=style&index=0&id=00b5e45a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b5e45a",
  null
  
)

export default component.exports